import React, { useMemo, useReducer } from 'react';
import PropTypes from 'prop-types';
import UiReducer from 'reducers/ui';
import UiContext from 'context/UiContext';
import ApiHelper from 'api/apiHelper';
import {
  LOADER_START,
  LOADER_STOP,
  SET_ERROR_MESSAGE,
  SET_SUCCESS_MESSAGE,
} from 'constants/actionTypes';

const initialState = {
  showLoader: 0,
  successMessage: '',
  errorMessage: '',
};

const UiProvider = (props) => {
  const [state, dispatch] = useReducer(UiReducer, initialState);

  const startLoader = (count) => {
    dispatch({ type: LOADER_START, showLoader: count || 1 });
  };

  const stopLoader = (count) => {
    dispatch({
      type: LOADER_STOP,
      showLoader: count ? count - 1 : 0,
    });
  };

  const setSuccessMessage = (message) => {
    dispatch({
      type: SET_SUCCESS_MESSAGE,
      successMessage: message,
    });
  };

  const setErrorMessage = (message) => {
    dispatch({
      type: SET_ERROR_MESSAGE,
      errorMessage: message,
    });
  };

  // Оборачиваем объект в useMemo
  const contextValue = useMemo(() => ({
    state,
    dispatch,
    startLoader,
    stopLoader,
    setSuccessMessage,
    setErrorMessage,
  }), [state, dispatch, startLoader, stopLoader, setSuccessMessage, setErrorMessage]);

  return (
    <UiContext.Provider
      value={contextValue}
    >
      <ApiHelper>{props.children}</ApiHelper>
    </UiContext.Provider>
  );
};

UiProvider.propTypes = {
  children: PropTypes.object.isRequired,
};

export default UiProvider;
